import { render, staticRenderFns } from "./GraphDetail16.vue?vue&type=template&id=2c174860&scoped=true"
import script from "./GraphDetail16.vue?vue&type=script&lang=js"
export * from "./GraphDetail16.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c174860",
  null
  
)

export default component.exports